// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/chat/v1/source.proto (package gdx.gateway.web.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * Message source data.
 *
 * @generated from message gdx.gateway.web.chat.v1.Source
 */
export class Source extends Message<Source> {
  /**
   * @generated from oneof gdx.gateway.web.chat.v1.Source.content
   */
  content: {
    /**
     * @generated from field: gdx.gateway.web.chat.v1.Unknown unknown = 1;
     */
    value: Unknown;
    case: "unknown";
  } | {
    /**
     * @generated from field: gdx.gateway.web.chat.v1.Organic organic = 2;
     */
    value: Organic;
    case: "organic";
  } | {
    /**
     * @generated from field: gdx.gateway.web.chat.v1.Generator generator = 3;
     */
    value: Generator;
    case: "generator";
  } | {
    /**
     * @generated from field: gdx.gateway.web.chat.v1.InternalOperator internal_operator = 4;
     */
    value: InternalOperator;
    case: "internalOperator";
  } | {
    /**
     * @generated from field: gdx.gateway.web.chat.v1.Lop2020Operator lop2020_operator = 5;
     */
    value: Lop2020Operator;
    case: "lop2020Operator";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Source>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.Source";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unknown", kind: "message", T: Unknown, oneof: "content" },
    { no: 2, name: "organic", kind: "message", T: Organic, oneof: "content" },
    { no: 3, name: "generator", kind: "message", T: Generator, oneof: "content" },
    { no: 4, name: "internal_operator", kind: "message", T: InternalOperator, oneof: "content" },
    { no: 5, name: "lop2020_operator", kind: "message", T: Lop2020Operator, oneof: "content" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Source {
    return new Source().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Source {
    return new Source().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Source {
    return new Source().fromJsonString(jsonString, options);
  }

  static equals(a: Source | PlainMessage<Source> | undefined, b: Source | PlainMessage<Source> | undefined): boolean {
    return proto3.util.equals(Source, a, b);
  }
}

/**
 * Unknown source.
 *
 * @generated from message gdx.gateway.web.chat.v1.Unknown
 */
export class Unknown extends Message<Unknown> {
  constructor(data?: PartialMessage<Unknown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.Unknown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Unknown {
    return new Unknown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Unknown {
    return new Unknown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Unknown {
    return new Unknown().fromJsonString(jsonString, options);
  }

  static equals(a: Unknown | PlainMessage<Unknown> | undefined, b: Unknown | PlainMessage<Unknown> | undefined): boolean {
    return proto3.util.equals(Unknown, a, b);
  }
}

/**
 * Organic source.
 *
 * @generated from message gdx.gateway.web.chat.v1.Organic
 */
export class Organic extends Message<Organic> {
  constructor(data?: PartialMessage<Organic>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.Organic";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Organic {
    return new Organic().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Organic {
    return new Organic().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Organic {
    return new Organic().fromJsonString(jsonString, options);
  }

  static equals(a: Organic | PlainMessage<Organic> | undefined, b: Organic | PlainMessage<Organic> | undefined): boolean {
    return proto3.util.equals(Organic, a, b);
  }
}

/**
 * Generator source.
 *
 * @generated from message gdx.gateway.web.chat.v1.Generator
 */
export class Generator extends Message<Generator> {
  /**
   * @generated from field: map<string, string> extra = 1;
   */
  extra: { [key: string]: string } = {};

  constructor(data?: PartialMessage<Generator>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.Generator";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "extra", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Generator {
    return new Generator().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Generator {
    return new Generator().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Generator {
    return new Generator().fromJsonString(jsonString, options);
  }

  static equals(a: Generator | PlainMessage<Generator> | undefined, b: Generator | PlainMessage<Generator> | undefined): boolean {
    return proto3.util.equals(Generator, a, b);
  }
}

/**
 * Internal operator.
 *
 * @generated from message gdx.gateway.web.chat.v1.InternalOperator
 */
export class InternalOperator extends Message<InternalOperator> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<InternalOperator>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.InternalOperator";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InternalOperator {
    return new InternalOperator().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InternalOperator {
    return new InternalOperator().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InternalOperator {
    return new InternalOperator().fromJsonString(jsonString, options);
  }

  static equals(a: InternalOperator | PlainMessage<InternalOperator> | undefined, b: InternalOperator | PlainMessage<InternalOperator> | undefined): boolean {
    return proto3.util.equals(InternalOperator, a, b);
  }
}

/**
 * External service operator.
 *
 * @generated from message gdx.gateway.web.chat.v1.Lop2020Operator
 */
export class Lop2020Operator extends Message<Lop2020Operator> {
  constructor(data?: PartialMessage<Lop2020Operator>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.Lop2020Operator";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Lop2020Operator {
    return new Lop2020Operator().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Lop2020Operator {
    return new Lop2020Operator().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Lop2020Operator {
    return new Lop2020Operator().fromJsonString(jsonString, options);
  }

  static equals(a: Lop2020Operator | PlainMessage<Lop2020Operator> | undefined, b: Lop2020Operator | PlainMessage<Lop2020Operator> | undefined): boolean {
    return proto3.util.equals(Lop2020Operator, a, b);
  }
}

